import React, { useState, useEffect } from 'react';
import { ThemeProvider } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import DataTable from './DataTable';
import PlannedIdleTime from './PlannedIdleTime';
import UnplannedIdleTime from './UnplannedIdleTime';
import IHFTime from './IHFTime';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
//Autocomplete
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSelector, useDispatch } from "react-redux";

const api = axios.create({
    baseURL: 'MasterDetails'
})

const apiSlip = axios.create({
    baseURL: 'SlipGeneration'
})

//const useStyles = makeStyles((theme: Theme) =>
//    createStyles({
//        container: {
//            display: 'flex',
//            flexWrap: 'wrap',
//        },
//    }),
//);


export default function SlipCreation(props) {
   // console.log("slip creation", props);
    //const classes = useStyles();

    //for progress
    const [openLoader, setopenLoader] = useState(false);

    //for Warning showing
    const [openWarning, setopenWarning] = useState(false);
    const [openAlertWarning, setopenAlertWarning] = useState("");
    const [openClassNameWarning, setopenClassNameWarning] = useState("");
    const [openTypeWarning, setopenTypeWarning] = useState("");
    const [alertwarningclass, setalertwarningclass] = useState("bg-amber clr-white");
    const [alertwarning, setalertwarning] = useState("Warning");

    //for error handling 
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [severity, setSeverity] = useState('success');

    //Autocomplete
    const [employeeObj, setEmployeeObj] = useState('');
    const [employeeText, setEmployeeText] = useState('');

    const handleChangeEmployee = (event, newValue) => {
      //  console.log(newValue);
        setEmployeeObj(newValue ? newValue : []);
        setEmployeeText(newValue ? newValue.empName : "");
        setemployeeValue(newValue ? newValue.employeeId : 0);
    };
    const handleChangeEmployeeInput = (event, newInputValue) => {
        setEmployeeText(newInputValue ? newInputValue : " ");
    };

    const handleErrorClose = (e) => {
        setIserror(false);
    }

    function handleCloseWarning() {
        setopenWarning(false);
    }

    //function getURLParameter(sParam) {
    //    var sPageURL = window.location.search.substring(1);
    //    var sURLVariables = sPageURL.split('&');
    //    for (var i = 0; i < sURLVariables.length; i++) {
    //        var sParameterName = sURLVariables[i].split('=');
    //        var value = '';
    //        for (var j = 0; j < sParameterName.length; j++) {
    //            if (sParameterName[j] == sParam) {
    //                for (var k = j + 1; k < sParameterName.length; k++) {
    //                    value = value + sParameterName[k];
    //                }
    //                break;
    //            }
    //            else {
    //                continue;
    //            }
    //        }
    //        return value;
    //    }       
    //}

    function getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            var value = getParamName(sParameterName, sParam);
            return value;
        }
    }

    function getParamName(sParameterName, sParam) {
        var value = '';
        for (var j = 0; j < sParameterName.length; j++) {
            if (sParameterName[j] == sParam) {
                value = value + getParanValue(j, sParameterName);
                break;
            }
            else {
                continue;
            }
        }
        return value;
    }

    function getParanValue(j, sParameterName) {
        var value = '';
        for (var k = j + 1; k < sParameterName.length; k++) {
            value = value + sParameterName[k];
        }
        return value;
    }

    const today = Date.now();
    let newdateformat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(today);
    let ldate = newdateformat.split("/")[2] + "-" + newdateformat.split("/")[0] + "-" + newdateformat.split("/")[1];
    const [entrydate, setentrydate] = useState(ldate);
    const [isDisabled, setisDisabled] = useState(true);
    const [employee, setemployee] = useState([]);
    const [employeeValue, setemployeeValue] = useState("");
    //const [employeeNameValue, setEmployeeNameValue] = useState("");
    //const [employeeNames, setEmployeeNames] = useState([]);
    const [mrp, setmrp] = useState([]);
    const [time, settime] = useState([]);
    const [date, setdate] = useState([]);
    const [mrpValue, setmrpValue] = useState('');
    const [shiftValue, setshiftValue] = useState('');
    const [slipGenId, setslipGenId] = useState(window.atob(getURLParameter("ID")) ? window.atob(getURLParameter("ID")) : props.SlipGenId);
    const [EntryNumberValue, setEntryNumberValue] = useState("");
    const [ViewEntryNumberValue, setViewEntryNumberValue] = useState("");
    const [WorkerShift, setWorkerShift] = useState([]);
    const [EnteredTimeValue, setEnteredTimeValue] = useState("");
    const [InputTimeValue, setInputTimeValue] = useState("");
    const [IdleTimeValue, setIdleTimeValue] = useState("");
    const [EfficiencyValue, setEfficiencyValue] = useState("");
    const [slipDataDetails, setslipDataDetails] = useState([]);
    const [slipDataPlanTime, setslipDataPlanTime] = useState([]);
    const [slipDataUnPlanTime, setslipDataUnPlanTime] = useState([]);
    const [slipDataIHFTime, setslipDataIHFTime] = useState([]);
    const [PlanTimeValue, setPlanTimeValue] = useState([]);
    const [UnPlanTimeValue, setUnPlanTimeValue] = useState([]);
    const [IHFTimeValue, setIHFTimeValue] = useState([]);
    const [NoWorkValue, setNoWorkValue] = useState(0);
    const [CreatedBy, setCreatedBy] = useState(props.loginuser.response.firstName + ' ' + props.loginuser.response.lastName);
    const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.response.employeeId);
    const [isSubmitDisabled, setisSubmitDisabled] = useState(true);
    const [ViewEfficiencyValue, setViewEfficiencyValue] = useState("");
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    //const [alertsuccess, setalertsuccess] = useState("Success");
    //const [alerterror, setalerterror] = useState("Alert");
    //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    //const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");
    const [Remarks, setRemarks] = useState("");

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);

    const handleRemarksChange = (event) => {
        setRemarks(event.target.value);
    };

    //const handleChangeEmp = (event) => {
    //    setemployeeValue(event.target.value);
    //};

    const handleChangeMrp = (event) => {
        setmrpValue(event.target.value);
    };

    const handleChangeShift = (event) => {
        setshiftValue(event.target.value);
    };

    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }
    //function dateChangeEvent(dateValue, label) {
    //    //alert(dateValue);
    //    if (dateValue !== null) {
    //        setentrydate(new Date(dateValue));
    //    }
    //    else {
    //        setentrydate(null);
    //    }
    //}

    function getTime() {
        var today = new Date(),
            time_1 = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        var today = new Date(),
            date_1 = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
        settime(time_1);
        setdate(date_1);
    }

    function clearState() {
        setEntryNumberValue("");
        setEnteredTimeValue("");
        setmrpValue("");
        setEfficiencyValue("");
        setemployeeValue("");
        setshiftValue("");
        setInputTimeValue("");
        setIdleTimeValue("");
        setViewEntryNumberValue("");
        setentrydate(null);
        setRemarks("");
        setEmployeeObj("");
        setEmployeeText("");
    }

    function getSlipGenHeader(slipGenHeadId) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        clearState();
        apiSlip.get('/getvwSlipGenHeader/' + slipGenHeadId,{
            headers: headers
        })
            .then(res => {
                setEntryNumberValue(res.data.entryNumber);
                setEnteredTimeValue(res.data.enteredTime);
                setmrpValue(res.data.mrpcontrollerId);
                setEfficiencyValue(res.data.efficiency);
                setemployeeValue(res.data.workerId);
                setshiftValue(res.data.workerShiftId);
                setInputTimeValue(res.data.inputTime);
                setIdleTimeValue(res.data.idleTime);
                setPlanTimeValue(res.data.plannedIdleTime);
                setUnPlanTimeValue(res.data.unPlannedIdleTime);
                setIHFTimeValue(res.data.ihftime);
                setViewEntryNumberValue("S" + res.data.entryNumber);
                setViewEfficiencyValue((res.data.efficiency) + '%');
                let entry = res.data.viewEntryDate.split("/")[2] + "-" + res.data.viewEntryDate.split("/")[1] + "-" + res.data.viewEntryDate.split("/")[0];
                setentrydate(entry);
                setCreatedBy(res.data.createdUser);
                setRemarks(res.data.remarks);
                getEmployees(res.data.workerId);
                //employee.filter(x => x.employeeId == res.data.workerId).map(filtered => {
                //    console.log(filtered);
                //    setEmployeeObj(filtered);
                //    setEmployeeText(filtered.employeeId ? filtered.employeeId : 0);
                //});
                getSlipGenDetails(slipGenHeadId);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. Employee")
            })
    }

    function getSlipGenDetails(slipGenHeadId) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let SlipGenId = Number(props.SlipGenId);
        if (Number(slipGenHeadId) > 0) {
            SlipGenId = Number(slipGenHeadId);
        }
        apiSlip.get("/getTrnSlipGenDetails/" + SlipGenId,{
            headers: headers
        })
            .then(res => {
                setopenLoader(false);
                setslipDataDetails(res.data)
                if (res.data.length > 0) {
                    setisSubmitDisabled(false);
                }
            })
            .catch(error => {
                console.log("Error in hitting api at page load. : SlipGenDetails")
            })
    }

    function getEmployees(id) {
        setemployee([]);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getAllEmployeeWorkers/',{
            headers: headers,
        })
            .then(res => {
                //debugger;
                setemployee(res.data);
                let empData = [];
                if (id > 0) {
                    empData = res.data;
                    empData.filter(x => x.employeeId == id).map(filtered => {
                       // console.log(filtered);
                        setEmployeeObj(filtered);
                        setEmployeeText(filtered.empName ? filtered.empName : "");
                    });
                }
            })
            .catch(error => {
                console.log("Error in hitting api at page load. Employee")
            })
    }

    function getMRP() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getTblMstMrpcontroller/',{
            headers: headers
        })
            .then(res => {
                setmrp(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. MRP Controller")
            })
    }

    function getShift() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getAllEmployeeShift/',{
            headers: headers
        })
            .then(res => {
                setWorkerShift(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. Shift")
            })
    }

    function saveSlipGenHeader() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let isValidate = true;
        let errorList = [];
        if (employeeValue == "" || employeeValue === null || employeeValue === undefined) {
            isValidate = false;
            //showMsg(true, "Select Employee", alerterrorclass, alerterror);
            errorList.push("Select Employee");
            showMessage(errorList, true, 'error');
        }
        if (mrpValue == "" || mrpValue === null || mrpValue === undefined) {
            isValidate = false;
            //showMsg(true, "Select MRP Controller", alerterrorclass, alerterror);
            errorList.push("Select MRP Controller");
            showMessage(errorList, true, 'error');
        }
        if (shiftValue == "" || shiftValue === null || shiftValue === undefined) {
            isValidate = false;
            //showMsg(true, "Select Shift", alerterrorclass, alerterror);
            errorList.push("Select Shift");
            showMessage(errorList, true, 'error');
        }
        if (entrydate === null || entrydate === undefined) {
            isValidate = false;
            //showMsg(true, "Select Entry Date.", alerterrorclass, alerterror);
            errorList.push("Select Entry Date.");
            showMessage(errorList, true, 'error');
        }
        if (isValidate) {
            setopenLoader(true);
            let slipGenHeadDet = {
                Id: Number(slipGenId),
                EntryNumber: EntryNumberValue,
                WorkerId: employeeValue,
                MrpcontrollerId: mrpValue,
                WorkerShiftId: shiftValue,
                EnteredTime: EnteredTimeValue,
                InputTime: InputTimeValue,
                IdleTime: IdleTimeValue,
                Efficiency: EfficiencyValue,
                CreatedBy: CreatedUserId,
                ModifiedBy: CreatedUserId,
                Status: 1,
                EntryDate: entrydate,
                Remarks: Remarks
            }
            let errorList = [];
            apiSlip.post("/SaveSlipGenHeader/", slipGenHeadDet,{
                headers: headers
            })
                .then(res => {
                    setslipGenId(res.data.result.id);
                    setEntryNumberValue(res.data.result.entryNumber);
                    setViewEntryNumberValue("S" + res.data.result.entryNumber);
                    setisDisabled(false);
                    setisSubmitDisabled(false);
                    setopenLoader(false);
                    localStorage.setItem("MRP", mrpValue);
                    if (EntryNumberValue === "" || EntryNumberValue === undefined || EntryNumberValue === null) {
                        const today = new Date(res.data.result.createdDate);
                        //let createdDate = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(today);
                        let createdDate = new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(today) + " " + new Intl.DateTimeFormat('en-US', { timeStyle: 'short' }).format(today);
                        errorList.push("Entry Number S" + res.data.result.entryNumber + " created successfully on " + createdDate + ".");
                        showMessage(errorList, true, 'success');
                    }
                    else {
                        const today = new Date(res.data.result.modifiedDate);
                        //let modifiedDate = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(today);
                        let modifiedDate = new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(today) + " " + new Intl.DateTimeFormat('en-US', { timeStyle: 'short' }).format(today);
                        errorList.push("Entry Number S" + res.data.result.entryNumber + " updated successfully on " + modifiedDate + ".");
                        showMessage(errorList, true, 'success');
                    }
                })
                .catch(error => {
                    errorList.push("Something went wrong.");
                    showMessage(errorList, true, 'error');
                    console.log(error);
                })
        }
    }

    function validateSlipGeader() {
        let isValidate = true;
        let errorList = [];
        if (EntryNumberValue === "" || EntryNumberValue === null || EntryNumberValue === undefined) {
            isValidate = false;
            //showMsg(true, "Generate Entry Number", alerterrorclass, alerterror);
            errorList.push("Generate Entry Number");
            showMessage(errorList, true, 'error');
        }
        if (employeeValue === "" || employeeValue === null || employeeValue === undefined) {
            isValidate = false;
            //showMsg(true, "Select Employee", alerterrorclass, alerterror);
            errorList.push("Select Employee");
            showMessage(errorList, true, 'error');
        }
        if (mrpValue === "" || mrpValue === null || mrpValue === undefined) {
            isValidate = false;
            //showMsg(true, "Select MRP Controller", alerterrorclass, alerterror);
            errorList.push("Select MRP Controller");
            showMessage(errorList, true, 'error');
        }
        if (shiftValue === "" || shiftValue === null || shiftValue === undefined) {
            isValidate = false;
            //showMsg(true, "Select Shift", alerterrorclass, alerterror);
            errorList.push("Select Shift");
            showMessage(errorList, true, 'error');
        }
        if (entrydate === null || entrydate === undefined) {
            isValidate = false;
            //showMsg(true, "Select Entry Date.", alerterrorclass, alerterror);
            errorList.push("Select Entry Date.");
            showMessage(errorList, true, 'error');
        }
        if (EnteredTimeValue === "" || EnteredTimeValue === null || EnteredTimeValue === undefined) {
            isValidate = false;
            //showMsg(true, "Add Slip Details : Entered Time", alerterrorclass, alerterror);
            errorList.push("Add Slip Details : Entered Time");
            showMessage(errorList, true, 'error');
        }
        if (InputTimeValue === "" || InputTimeValue === null || InputTimeValue === undefined) {
            isValidate = false;
            //showMsg(true, "Add Slip Details : Input Time", alerterrorclass, alerterror);
            errorList.push("Add Slip Details : Input Time");
            showMessage(errorList, true, 'error');
        }
        if (EfficiencyValue === "" || EfficiencyValue === null || EfficiencyValue === undefined) {
            isValidate = false;
            //showMsg(true, "Calculate Efficiency.", alerterrorclass, alerterror);
            errorList.push("Calculate Efficiency.");
            showMessage(errorList, true, 'error');
        }
        return isValidate;
    }

    function submitForm() {
        let inputmin = Number(InputTimeValue);
        if (inputmin < 480) {
            setopenWarning(true);
            setopenAlertWarning("Input Min should be 480.");
            setopenClassNameWarning(alertwarningclass);
            setopenTypeWarning(alertwarning);
        }
        else {
            submitSlipGenHeader();
        }
    }

    function submitSlipGenHeader() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };   
        setopenLoader(true);
        if (validateSlipGeader()) {
            let slipGenHeadDet = {
                Id: Number(slipGenId),
                EntryNumber: EntryNumberValue,
                WorkerId: employeeValue,
                MrpcontrollerId: mrpValue,
                WorkerShiftId: shiftValue,
                EnteredTime: EnteredTimeValue,
                InputTime: InputTimeValue,
                IdleTime: IdleTimeValue,
                Efficiency: EfficiencyValue,
                ModifiedBy: CreatedUserId,
                Status: 2,
                EntryDate: entrydate,
                Remarks: Remarks
            }
            let errorList = [];
            apiSlip.post("/SaveSlipGenHeader/", slipGenHeadDet,{
                headers: headers
            })
                .then(res => {
                    setopenLoader(false);
                    errorList.push("Entry Number S" + res.data.result.entryNumber + " submitted successfully.");
                    localStorage.setItem("MRP", mrpValue);
                    showMessage(errorList, true, 'success');
                    window.location.href = "/Summary";
                })
                .catch(error => {
                    errorList.push("Something went wrong.");
                    showMessage(errorList, true, 'error');
                    console.log(error);
                })
        }
        else {
            setopenLoader(false);
        }
    }

    function getDataFromDataTable(data) {
        //console.log(data.length);
        setslipDataDetails(data);
        let outputtime = 0;
        let inputtime = 0;

        for (let i = 0; i <= data.length - 1; i++) {
            if (Number(data[i].workingMethodId) === 1) {
                outputtime = outputtime + Number(data[i].outputMins);
                inputtime = inputtime + Number(data[i].inputMin);
            }
        }
        setEnteredTimeValue(outputtime);
        setInputTimeValue(inputtime);
        calculateEfficiency_manual(outputtime, inputtime, IdleTimeValue, NoWorkValue);
    }

    function getDataFromPlanTime(data) {
        //console.log(data.length);
        setslipDataPlanTime(data);
        let plantime = 0;

        for (let i = 0; i <= data.length - 1; i++) {
            plantime = plantime + Number(data[i].plannedIdleTimeValue);
        }
        setPlanTimeValue(plantime);
        calIdleTime(plantime, UnPlanTimeValue, IHFTimeValue, NoWorkValue);
    }

    function getDataFromUnPlanTime(data) {
        setslipDataUnPlanTime(data);
        let nowork = 0;
        let unplantime = 0;
        for (let i = 0; i <= data.length - 1; i++) {
            unplantime = unplantime + Number(data[i].unPlannedIdleTimeValue);
            if (Number(data[i].unPlannedIdleTimeId) === 4) {
                nowork = nowork + Number(data[i].unPlannedIdleTimeValue);
            }
        }
        setNoWorkValue(nowork);
        setUnPlanTimeValue(unplantime);
        calIdleTime(PlanTimeValue, unplantime, IHFTimeValue, nowork)
    }

    function getDataFromIHFTime(data) {
        setslipDataIHFTime(data);

        let ihftime = 0;
        for (let i = 0; i <= data.length - 1; i++) {
            ihftime = ihftime + Number(data[i].ihfvalue);
        }
        setIHFTimeValue(ihftime);
        calIdleTime(PlanTimeValue, UnPlanTimeValue, ihftime, NoWorkValue)
    }

    function calIdleTime(plantime, unplantime, ifhtime, nowork) {
        let idletime = 0;
        //idletime = Number(plantime) + Number(unplantime) + Number(ifhtime);
        idletime = Number(plantime) + Number(ifhtime);
        setIdleTimeValue(idletime);
        calculateEfficiency_manual(EnteredTimeValue, InputTimeValue, idletime, nowork);
    }

    function calculateEfficiency_manual(enteredTimeValue, inputTimeValue, idleTimeValue, noWorkValue) {
        //let idletime = ((inputTimeValue - idleTimeValue) + noWorkValue);
        let idletime = inputTimeValue - idleTimeValue - noWorkValue;
        let efficiency = 0;
        if (inputTimeValue > idleTimeValue) {
            efficiency = enteredTimeValue / idletime;
            efficiency = efficiency * 100;
            efficiency = efficiency.toFixed(2);
        }
        setEfficiencyValue(efficiency.toString());
        setViewEfficiencyValue(efficiency.toString() + '%');
    }

    function calculateEfficiency() {
        //let idletime = ((InputTimeValue - IdleTimeValue) + NoWorkValue);
        let idletime = InputTimeValue - IdleTimeValue - NoWorkValue;
        let efficiency = 0;
        if (InputTimeValue > IdleTimeValue) {
            efficiency = EnteredTimeValue / idletime;
            efficiency = efficiency * 100;
            efficiency = efficiency.toFixed(2);
        }
        setEfficiencyValue(efficiency.toString());
        setViewEfficiencyValue(efficiency.toString() + '%');
    }

    //function showMsg(popen, popenAlert, popenClassName, popenType) {
    //    setopen(popen);
    //    setopenAlert(popenAlert);
    //    setopenClassName(popenClassName);
    //    setopenType(popenType);        
    //}

    function handleClose() {
        setopen(false);
    }

    //const handleChangeEmployee_Autocomplete = (event, newValue) => {
    //    if (newValue != null) {
    //        setemployeeValue(newValue.employeeId);
    //        employee.filter(x => x.employeeId == newValue.employeeId).map(filtered => { setEmployeeNames(filtered); setEmployeeNameValue(filtered.empName); });
    //    }
    //    else {
    //        setemployeeValue(0);
    //        setEmployeeNameValue("");
    //        setEmployeeNames([]);
    //    }
    //};

    function getSelectedMRP() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        apiSlip.get("/getSavedMRPController/" + CreatedUserId,{
            headers: headers,
        })
            .then(res => {
                //console.log(res);
                setmrpValue(res.data.result);
                localStorage.setItem("MRP", res.data.result)
            })
            .catch(error => {
                console.log("Error in hitting api at page load. : getSavedMRPController")
            })
    }

    useEffect(() => {
        var id = window.atob(getURLParameter("ID"));
        setslipGenId(id);
        getTime();
        getMRP();
        getShift();
        if (Number(id) > 0) {
            setopenLoader(true);
            getSlipGenHeader(id);
            setisDisabled(false);
        }
        else {
            getEmployees(0);
            if (localStorage.getItem("MRP") == "" || localStorage.getItem("MRP") === null || localStorage.getItem("MRP") === undefined) {
                getSelectedMRP();
            }
            else {
                setmrpValue(localStorage.getItem("MRP"));
            }
        }
    }, []);

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">Slip Creation</h3>
                </Box>
                <Grid container spacing={2} className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius ">
                    <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields  "
                            id="entryNumber"
                            disabled={true}
                            label="Entry Number"
                            variant="filled"
                            fullWidth
                            name="Entry Number"
                            value={ViewEntryNumberValue}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100">
                        <TextField className="lightInputFields  "
                            id="CreatedDate"
                            disabled={true}
                            label="Created Date"
                            variant="filled"
                            fullWidth
                            name="Created Date"
                            value={date}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">
                        <TextField className="lightInputFields  "
                            id="createdBy"
                            disabled={true}
                            label="Created By"
                            variant="filled"
                            fullWidth
                            name="Created By"
                            value={CreatedBy}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields"
                            id="CreatedTime"
                            disabled={true}
                            label="Created Time"
                            variant="filled"
                            fullWidth
                            name="Created Time"
                            value={time}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <Autocomplete
                            className="lightInputFields"
                            id="Autocomplete_employee"
                            fullWidth
                            value={employeeObj}
                            inputValue={employeeText}
                            options={employee}
                            getOptionLabel={option => option.empName ? option.empName : ""}
                            onChange={handleChangeEmployee}
                            onInputChange={handleChangeEmployeeInput}
                            renderInput={
                                (params) =>
                                    <TextField {...params}
                                        label="*Employee"
                                    //required
                                    //error={errorsupervisoryOrganization}
                                    //helperText={errorTextsupervisoryOrganization}
                                    />
                            }
                        //disabled={props.disableValue}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl variant="filled" className="reg-form--division-icon" fullWidth>
                            <InputLabel id="demo-controlled-open-select-label">*MRP Controller</InputLabel>
                            <Select
                                labelId="demo-controlled-open-select-label"
                                id="demo-controlled-open-select"
                                value={mrpValue}
                                onChange={handleChangeMrp}
                            >
                                {
                                    mrp.map((h, i) =>
                                        (<MenuItem key={i} value={h.mrpcontrollerId}>{h.mrpcontroller}</MenuItem>))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <TextField
                            id="entrydate"
                            label="*Entry Date"
                            type="date"
                            fullWidth
                            className="lightInputFields"
                            //className={classes.textField}
                            //defaultValue={entrydate}                                
                            InputLabelProps={{
                                shrink: true,
                            }}
                            //value={entrydate}
                            //onChange={dateChangeEvent}
                            value={entrydate}
                            onChange={event => setentrydate(event.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl variant="filled" className="reg-form--division-icon" fullWidth>
                            <InputLabel id="demo-controlled-open-select-label">*Shift</InputLabel>
                            <Select
                                labelId="demo-controlled-open-select-label"
                                id="demo-controlled-open-select"
                                value={shiftValue}
                                onChange={handleChangeShift} >
                                {
                                    WorkerShift.map((h, i) =>
                                        (<MenuItem key={i} value={h.shiftId}>{h.shiftName}</MenuItem>))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <TextField className="lightInputFields  "
                            id="enteredTime"
                            disabled={true}
                            label="Entered Time (SMM)"
                            variant="filled"
                            fullWidth
                            name="Entered Time"
                            value={EnteredTimeValue}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <TextField className="lightInputFields"
                            id="inputTime"
                            disabled={true}
                            label="Input Time (AMM)"
                            variant="filled"
                            fullWidth
                            name="Input Time"
                            value={InputTimeValue}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <TextField className="lightInputFields"
                            id="idleTime"
                            disabled={true}
                            label="Idle/IHF Time"
                            variant="filled"
                            fullWidth
                            name="Idle/IHF Time"
                            value={IdleTimeValue}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <TextField className="lightInputFields"
                            id="efficiency"
                            disabled={true}
                            label="Efficiency"
                            variant="filled"
                            fullWidth
                            name="Efficiency"
                            value={ViewEfficiencyValue}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">

                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={calculateEfficiency}>
                            <span>Calculate Efficiency</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={saveSlipGenHeader}>
                            <span>Save</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" disabled={isSubmitDisabled} onClick={submitForm}>
                            <span>Submit</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                    </Grid>
                    <Grid item xs={12} sm={12} className="d-flex Width-100">
                        <DataTable SlipGenId={slipGenId} getHeaderCalculation={getDataFromDataTable.bind(this)} MrpcontrollerId={mrpValue} isDisabled={isDisabled} loginuser={props.loginuser} />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex no-thead Width-100">
                        <PlannedIdleTime SlipGenId={slipGenId} getHeaderPlanCal={getDataFromPlanTime.bind(this)} />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex no-thead Width-100">
                        <UnplannedIdleTime SlipGenId={slipGenId} getHeaderUnPlanCal={getDataFromUnPlanTime.bind(this)} />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex no-thead Width-100">
                        <IHFTime SlipGenId={slipGenId} getHeaderIHFPlanCal={getDataFromIHFTime.bind(this)} />
                    </Grid>
                    {
                        slipGenId > 0 ?
                            (
                                <Grid item xs={12} sm={3} className="d-flex no-thead Width-100">
                                    <textarea className="lightInputFields bgtextarea"
                                        id="remarks"
                                        label="Remarks"
                                        placeholder="Remarks"
                                        variant="filled"
                                        name="Remarks"
                                        value={Remarks}
                                        onChange={handleRemarksChange}
                                    />
                                </Grid>
                            ) : <React.Fragment></React.Fragment>
                    }

                    {
                        slipDataDetails.length > 0 ?
                            (
                                <div className="d-flex jc-center width-100">
                                    <Button item xs={6} sm={5} className="ns-btn-primary mt-1 mr-1" onClick={saveSlipGenHeader}>
                                        <span>Save</span>
                                    </Button>
                                    <Button item xs={6} sm={5} className="ns-btn-primary mt-1 mr-1" disabled={isSubmitDisabled} onClick={submitSlipGenHeader}>
                                        <span>Submit</span>
                                    </Button>
                                </div>
                            ) : <React.Fragment></React.Fragment>
                    }
                </Grid>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess">
                    <DialogTitle className={openClassName} style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {openType}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="clr-black">
                            {openAlert}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">OK</span>
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openWarning}
                    onClose={handleCloseWarning}
                    aria-labelledby="draggable-dialog-title"
                    id="Submit">
                    <DialogTitle className={openClassNameWarning} style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {openTypeWarning}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="clr-black">
                            {openAlertWarning}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={submitSlipGenHeader} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">Submit</span>
                        </Button>
                        <Button variant="contained" autoFocus onClick={handleCloseWarning} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">Cancel</span>
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}


